"use strict";

const moment = require("moment-timezone");

class DateUtil {
  static dateStringToAWSDateTime(dateString) {
    if (dateString == null) {
      return null;
    }

    return dateString + "T00:00:00.000+01:00";
  }

  /**
   * Ignoruje TimeZone a vlozi priznak ZULU/UTC na postgresu je timestamp without TZ, takze se to bude ignorovat
   * Dulezite je zde neprovodet zadne casove posuny.
   * @param {*} date 
   */
  static dateToAWSDateTime(date) {
    if(date == null) {
      return null;
    }

    return moment(date).tz("Europe/Prague").format();
    
  }

  static awsDateTimeToJSDate(awsDateTime) {
    return moment(awsDateTime).toDate();
  }
}

module.exports = DateUtil;
